import { render, staticRenderFns } from "./ZonasEntregas.vue?vue&type=template&id=6382a535&scoped=true"
import script from "./ZonasEntregas.vue?vue&type=script&lang=js"
export * from "./ZonasEntregas.vue?vue&type=script&lang=js"
import style0 from "./ZonasEntregas.vue?vue&type=style&index=0&id=6382a535&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6382a535",
  null
  
)

export default component.exports